import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { ReviewHotelItinerary } from "./component";

import {
  getHotelShopCancellationSummary,
  getHotelShopChosenProduct,
  getHotelShopChosenRoomInfo,
  getHotelShopDateRange,
  getPackageSelectedLodging,
  getSelectedPackageByLodgingId,
} from "../../../hotel-shop/reducer";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
  getPackageAvailabilityInfants,
} from "../../../availability/reducer";
import { getPackagedRoomComponent } from "../../../package-identity/reducer/selectors";
import {
  toCancellationSummary,
  toHotelCancellationPolicyV2,
  toRoomInfoProducts,
} from "../../../hotel-shop/utils/packageSnapshotAdapters";

const mapStateToProps = (state: IStoreState) => {
  const hotelDates = getHotelShopDateRange(state);
  const packagedRoomComponentV2 = getPackagedRoomComponent(state);

  return {
    selectedLodging: getPackageSelectedLodging(state),
    checkIn: hotelDates?.from,
    checkOut: hotelDates?.until,
    chosenProduct: getHotelShopChosenProduct(state),
    selectedPackageByLodging: getSelectedPackageByLodgingId(state),
    roomInfo: getHotelShopChosenRoomInfo(state),
    cancellationSummary: getHotelShopCancellationSummary(state),
    searchAdultsCount: getPackageAvailabilityAdultsCount(state),
    searchChildren: getPackageAvailabilityChildren(state),
    searchedInfants: getPackageAvailabilityInfants(state),
    // v2-sourced: read from the GetPackage snapshot instead of the handoff.
    packagedRoomComponentV2,
    roomInfoV2: packagedRoomComponentV2
      ? toRoomInfoProducts(packagedRoomComponentV2)
      : undefined,
    cancellationSummaryV2: packagedRoomComponentV2
      ? toCancellationSummary(packagedRoomComponentV2)
      : undefined,
    cancellationPolicyV2Snapshot: packagedRoomComponentV2?.shopDetails
      ?.cancellationPolicyV2
      ? toHotelCancellationPolicyV2(
          packagedRoomComponentV2.shopDetails.cancellationPolicyV2
        )
      : undefined,
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ReviewHotelItineraryConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedReviewHotelItinerary = withRouter(
  connector(ReviewHotelItinerary)
);
